import type { Material } from "@/hooks/useBioNexusData";

type MaterialLike = Pick<
  Material,
  "degradation_value" | "degradation_days" | "tensile_strength_mpa" | "electrical_performance" | "water_resistance" | "cost_per_kg" | "source_doi" | "source_paper"
>;

export const countMeasured = (m: Partial<MaterialLike>) =>
  [m.degradation_value || m.degradation_days, m.tensile_strength_mpa, m.electrical_performance, m.water_resistance, m.cost_per_kg].filter(Boolean)
    .length;

export const isCompleteData = (m: Partial<MaterialLike>) => countMeasured(m) >= 3 && !!(m.source_doi || m.source_paper);

export const degradationLabel = (m: Partial<MaterialLike>) =>
  m.degradation_value || (m.degradation_days ? `${m.degradation_days} days` : null);
